module.exports = __webpack_public_path__ + "img/1_012.d8e2473a.jpg";